import { ListSchema, FilterSchema } from '@/schema/list'

export default {
  loading: false,
  data: {},
  id: null,
  resourceType: 'forschungsprojekt',
  listSchema: ListSchema,
  filterSchema: FilterSchema,
  filter: {
    forschungsprojekt: {
      kumuliert: false
    },
    kooperation: {
      kumuliert: false
    },
    publikation: {
      kumuliert: false
    },
    person: {},
    organisationseinheit: {},
    abstractperson: {},
    veranstaltung: {
      kumuliert: false
    },
    preis: {
      kumuliert: false
    },
    externeorganisation: {},
    patent: {
      kumuliert: false
    },
    land: {},
    appuser: {},
    mittelgeber: {}
  },
  config: {
    forschungsprojekt: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    kooperation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    publikation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    veranstaltung: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    preis: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    abstractperson: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    organisationseinheit: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    person: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    externeorganisation: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    patent: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    land: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    appuser: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    },
    mittelgeber: {
      page: 1,
      perPage: 20,
      sortField: null,
      sortOrder: 'asc'
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/list/state.js